export default __webpack_public_path__ + "4bcba86e1262a07b6d92834ae76a35a3.png";